"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSubmitReadCXToKapiOpeningGas = exports.mapSubmitReadCXToKapiOpeningElectricity = exports.mapSubmitReadCXToKapiGas = exports.mapSubmitReadCXToKapiElectricity = void 0;
var date_fns_1 = require("date-fns");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var constants_1 = require("../../constants");
var utils_1 = require("../../utils");
var customerSubmitReadTypes = {
    lifecycle: __generated__1.ReadingLifecycle.Inlife,
    type: __generated__1.ReadingType_NextV1.Actual,
    source: __generated__1.MeterReadSource.ManualReadCustomer,
};
var mapSubmitReadCXToKapiElectricity = function (data) { return (__assign(__assign({ sprn: data.sprn, meterSerialNumber: data.meterSerialNumber, dateTime: getISODate(data.dateTime) }, customerSubmitReadTypes), { force: data.force, registers: data.registers.map(function (_a) {
        var value = _a.value, registerId = _a.registerId;
        return ({
            value: value,
            registerId: registerId,
        });
    }) })); };
exports.mapSubmitReadCXToKapiElectricity = mapSubmitReadCXToKapiElectricity;
var mapSubmitReadCXToKapiGas = function (data) { return (__assign(__assign({ sprn: data.sprn, meterSerialNumber: data.meterSerialNumber, dateTime: getISODate(data.dateTime) }, customerSubmitReadTypes), { force: data.force, value: data.registers[0].value })); };
exports.mapSubmitReadCXToKapiGas = mapSubmitReadCXToKapiGas;
var mapSubmitReadCXToKapiOpeningElectricity = function (data) { return ({
    sprn: data.sprn,
    date: (0, date_fns_1.format)(data.dateTime, constants_1.DATE_API_FORMAT),
    source: __generated__1.MeterReadSource.ManualReadCustomer,
    registers: data.registers.map(function (_a) {
        var _b;
        var value = _a.value, timeOfUseLabel = _a.timeOfUseLabel;
        return ({
            value: value,
            timingCategory: (_b = (0, utils_1.timeOfUseLabelToTimingCategory)(timeOfUseLabel)) !== null && _b !== void 0 ? _b : __generated__1.SupplyPointTimingCategory.Anytime,
        });
    }),
}); };
exports.mapSubmitReadCXToKapiOpeningElectricity = mapSubmitReadCXToKapiOpeningElectricity;
var mapSubmitReadCXToKapiOpeningGas = function (data) { return ({
    sprn: data.sprn,
    date: (0, date_fns_1.format)(data.dateTime, constants_1.DATE_API_FORMAT),
    source: __generated__1.MeterReadSource.ManualReadCustomer,
    value: data.registers[0].value,
}); };
exports.mapSubmitReadCXToKapiOpeningGas = mapSubmitReadCXToKapiOpeningGas;
var getISODate = function (date) {
    return date ? (0, date_fns_1.parseISO)(date).toISOString() : new Date().toISOString();
};
